import gql from 'graphql-tag';

export default gql`
  fragment EmailStatusFields on EmailStatusType {
    status
    reason
  }
`;
